export class VerifyRdsCdcSqlSetupResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workflowNamespace",
            "baseName": "workflowNamespace",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VerifyRdsCdcSqlSetupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
